module.exports = __webpack_public_path__ + "static/media/excavation-2.a6c3a1de.jpg";